import styled from 'styled-components';

export const Image = styled.img`
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
`;
